<template>
  <div
    v-for='(related, key) in relationFields'
    :key='related'
    class='px-2'
  >
    <RelationField
      v-model='relationFields[key]'
      :model-value='related'
      :edit-mode='editMode'
      :name='field.key + "_" + key'
      :field='field'
      :label='label'
      :is-multi-field='true'
      :selected-options='relationFields'
      @update:model-value='checkRelationField'
    />
  </div>
  <div
    v-if='editMode && hasMoreOptions && field.editable'
    class='flex w-full cursor-pointer flex-row items-center rounded-md border-2 border-dashed border-gray-300 py-3 px-2'
    @click='addRelationField'
  >
    <PlusCircleIcon class='mx-3 h-8 w-8 text-gray-400'/>
    <span class='text-sm font-medium'>Add {{ field.label }}</span>
  </div>
  <div v-if='!editMode && !modelValue?.length > 0'>
    <span class='text-sm font-medium'>None</span>
  </div>
</template>

<script lang="ts">
  import { defineComponent, onMounted, ref, watch } from 'vue'
  import { PlusCircleIcon } from '@heroicons/vue/outline'
  import useInputFieldBase, { InputFieldProps } from '@/compositions/useInputFieldBase'
  import { InputFieldHasHelpProps } from '@/compositions/useInputFieldHasHelp'
  import { useAppStore } from '@/store/app'

  export default defineComponent({
    name: 'MultiRelationField',
    components: {
      PlusCircleIcon,
    },
    props: {
      ...InputFieldProps,
      ...InputFieldHasHelpProps,
    },
    setup(props) {
      const { updateValue } = useInputFieldBase()
      const relationFields = ref([])
      const appStore = useAppStore()

      onMounted(() => {
        relationFields.value = props.modelValue || []
      })

      const addRelationField = () => {
        if (!relationFields.value.includes(null)) relationFields.value.push(null)
      }

      const checkRelationField = (id?: number) => {
        if (id) {
          updateValue(relationFields.value)
        } else {
          deleteField(id)
        }

      }

      const hasMoreOptions = ref(true)

      watch(() => relationFields.value?.length >= appStore.optionsLoaded.get(String(props.field.id))?.length ?? 0, (newValue) => {
        if (appStore.optionsLoaded.has(String(props.field.id))) {
          hasMoreOptions.value = !newValue
        }
      }, {
        immediate: true,
      })

      const deleteField = (id?: number) => {
        relationFields.value = relationFields.value.filter(item => item !== null)
        if (id !== null) {
          relationFields.value = relationFields.value.filter((related: number) => {
            return related !== id
          })
        }
        updateValue(relationFields.value)
      }

      return {
        relationFields,
        addRelationField,
        deleteField,
        checkRelationField,
        hasMoreOptions,
      }
    },
  })
</script>
